type property = { name: string | string[], units: unit[] };
type unit = { name: string | string[], factor?: number, offset?: number };  // factor and offset are optional

export var dbProperties: property[] = [
  {
    name: ["dimensionless", "number", "nombre sans dimension"],
    units: [
      {
        name: [""]
      },
      {
        name: ["dozen"],
        factor: 1.2e1
      },
      {
        name: ["gross"],
        factor: 1.44e2
      },
      {
        name: ["half"],
        factor: 0.5
      },
      {
        name: ["quarter"],
        factor: 0.25
      },
      {
        name: ["pair"],
        factor: 2
      },
      {
        name: ["unit"]
      },
      {
        name: ["baker's dozen"],
        factor: 1.3e1
      },
      {
        name: ["score"],
        factor: 2.e1
      },
      {
        name: ["%", "percent"],
        factor: 1.e-2
      }
    ]
  },
  {
    name: ["angle"],
    units: [
      {
        name: ["deg", "degrees"],
        factor: 1.74532925199433e-2
      },
      {
        name: ["rad", "radians"]
      },
      {
        name: ["centrad", "centiradian"],
        factor: 1.0e-2
      },
      {
        name: ["gr", "grad", "gradient"],
        factor: 1.5707963267949e-2
      },
      {
        name: ["s", "seconds"],
        factor: 4.84813681109536e-6
      },
      {
        name: ["min", "minutes"],
        factor: 2.90888208665722e-4
      },
      {
        name: ["quad", "quadrants"],
        factor: 1.5707963267949
      },
      {
        name: ["right angles"],
        factor: 1.5707963267949
      },
      {
        name: ["revs", "revolutions"],
        factor: 6.28318530717959
      },
      {
        name: ["cycles"],
        factor: 6.28318530717959
      },
      {
        name: ["mils"],
        factor: 9.81747704246812e-4
      }
    ]
  },
  {
    name: ["time", "temps"],
    units: [
      {
        name: ["s", "second"]
      },
      {
        name: ["days", "jours"],
        factor: 8.64e4
      },
      {
        name: ["hr", "hours", "heures"],
        factor: 3.6e3
      },
      {
        name: ["min"],
        factor: 6.e1
      },
      {
        name: ["ms"],
        factor: 1.e-3
      },
      {
        name: ["us"],
        factor: 1.e-6
      },
      {
        name: ["ns"],
        factor: 1.e-9
      },
      {
        name: ["years", "annees"],
        factor: 3.155692597546e7
      }
    ]
  },
  {
    name: ["distance", "length", "displacement", "width", "height", "depth", "distance", "longueur"],
    units: [
      {
        name: ["m", "metres", "meters"]
      },
      {
        name: ["cm"],
        factor: 1.e-2
      },
      {
        name: ["mm"],
        factor: 1.e-3
      },
      {
        name: ["km", "kilometers", "kilometres"],
        factor: 1.e3
      },
      {
        name: ["microns"],
        factor: 1.e-6
      },
      {
        name: ["ft", "feet", "foot"],
        factor: 3.048e-1
      },
      {
        name: ["yd", "yards"],
        factor: 9.144e-1
      },
      {
        name: ["in", "inches"],
        factor: 2.54e-2
      },
      {
        name: ["miles", "miles(statute)"],
        factor: 1.609344e3
      },
      {
        name: ["miles(US,naut)"],
        factor: 1.852e3
      }
    ]
  },
  {
    name: ["mass", "weight", "masse", "poids"],
    units: [
      {
        name: ["kg", "kilograms", "kilogrammes"]
      },
      {
        name: ["g", "grams", "grammes"],
        factor: 1.e-3
      },
      {
        name: ["mg"],
        factor: 1.e-6
      },
      {
        name: ["tons(metric)", "tonnes"],
        factor: 1.e3
      },
      {
        name: ["lb(avdp)", "pounds"],
        factor: 4.5359237e-1
      },
      {
        name: ["pounds(Br)"],
        factor: 4.5359237e-1
      },
      {
        name: ["oz(avdp)", "ounces"],
        factor: 2.83495231e-2
      },
      {
        name: ["ounces(Br)"],
        factor: 2.83495231e-2
      },
      {
        name: ["stones(Br)"],
        factor: 6.35029318
      },
      {
        name: ["oz(troy)", "ounces"],
        factor: 3.110348e-2
      },
      {
        name: ["lb(troy)", "pounds"],
        factor: 3.732417e-1
      },
      {
        name: ["cwt(short)", "hundredweight"],
        factor: 4.5359237e1
      },
      {
        name: ["cwt(long)", "hundredweight"],
        factor: 5.080234544e1
      },
      {
        name: ["quarters(US short)", "qtr"],
        factor: 2.26796e2
      },
      {
        name: ["quarters(US long)", "qtr"],
        factor: 2.54012e2
      },
      {
        name: ["tons(short,US)"],
        factor: 9.0718474e2
      },
      {
        name: ["tons(long,Br)"],
        factor: 1.0160469088e3
      },
      {
        name: ["tons(assay)"],
        factor: 2.9166667e-2
      },
      {
        name: ["t"],
        factor: 1.e3
      }
    ]
  },
  {
    name : ["temperature"],
    units: [
      {
        name : ["K","Kelvin"]
      },
      {
        name : ["C","Centigrade","Celsius"],
        factor : 1.,
        offset : -2.7315e2
      },
      {
        name : ["F","Fahrenheit"],
        factor : 5.555555555555555e-1,
        offset : -4.5967e2
      },
      {
        name : ["R","Rankine"],
        factor : 5.555555555555555e-1
      },
      {
        name : ["Reaumur"],
        factor : 1.25,
        offset : -2.1852e2
      }
    ]
  },
  {
    name: ["velocity", "speed", "vitesse"],
    units: [
      {
        name: ["m/s"]
      },
      {
        name: ["kph"],
        factor: 2.77777777777778e-1
      },
      {
        name: ["mph", "miles/hr"],
        factor: 4.4704e-1
      },
      {
        name: ["knots"],
        factor: 5.14444444444445e-1
      },
      {
        name: ["ips"],
        factor: 2.54e-2
      },
      {
        name: ["ft/s"],
        factor: 3.048e-1
      },
      {
        name: ["m/min"],
        factor: 1.66666666666667e-2
      },
      {
        name: ["m/hr"],
        factor: 2.77777777777778e-4
      },
      {
        name: ["cm/s"],
        factor: 1.e-2
      },
      {
        name: ["cm/min"],
        factor: 1.66666666666667e-4
      },
      {
        name: ["cm/hr"],
        factor: 2.77777777777778e-6
      },
      {
        name: ["mm/s"],
        factor: 1.e-3
      },
      {
        name: ["mm/min"],
        factor: 1.66666666666667e-5
      },
      {
        name: ["mm/hr"],
        factor: 2.77777777777778e-7
      },
      {
        name: ["mm/day"],
        factor: 1.15740740740741e-8
      },
      {
        name: ["mm/year"],
        factor: 3.17097919837646e-11
      },
      {
        name: ["km/s"],
        factor: 1.e3
      },
      {
        name: ["km/min"],
        factor: 1.66666666666667e1
      },
      {
        name: ["km/hr"],
        factor: 2.77777777777778e-1
      },
      {
        name: ["ft/hr"],
        factor: 8.46666666666667e-5
      },
      {
        name: ["ft/min"],
        factor: 5.08e-3
      },
      {
        name: ["miles/s"],
        factor: 1.609344e3
      },
      {
        name: ["miles/min"],
        factor: 2.68224e1
      },
      {
        name: ["min/mile"],
        factor: -2.68224e1
      },
      {
        name: ["min/km"],
        factor: -1.66666666666667e1
      },
      {
        name: ["s/mile"],
        factor: -1.609344e3
      },
      {
        name: ["s/km"],
        factor: -1.e3
      }
    ]
  },
  {
    name: ["area", "aire", "surface"],
    units: [
      {
        name: ["m2"]
      },
      {
        name: ["km2"],
        factor: 1.e6
      },
      {
        name: ["sq.miles"],
        factor: 2.589988e6
      },
      {
        name: ["sq.ft"],
        factor: 9.290304e-2
      },
      {
        name: ["sq.in"],
        factor: 6.4516e-4
      },
      {
        name: ["ha"],
        factor: 1.e4
      },
      {
        name: ["acres"],
        factor: 4.0468564224e3
      },
      {
        name: ["arpent"],
        factor: 3.44266076e3
      },
      {
        name: ["barn"],
        factor: 1.e-28
      },
      {
        name: ["cm2"],
        factor: 1.e-4
      },
      {
        name: ["mm2"],
        factor: 1.e-6
      },
      {
        name: ["sq.microns"],
        factor: 1.e-12
      },
      {
        name: ["ares"],
        factor: 1.e2
      },
      {
        name: ["hectares"],
        factor: 1.e4
      }
    ]
  },
  {
    name: ["volume"],
    units: [
      {
        name: ["cu.m", "cubic metres", "cubic meters"]
      },
      {
        name: ["cc"],
        factor: 1.e-6
      },
      {
        name: ["l", "litre", "liter"],
        factor: 1.e-3
      },
      {
        name: ["ml"],
        factor: 1.e-6
      },
      {
        name: ["cu.ft", "cubic feet"],
        factor: 2.8316846592e-2
      },
      {
        name: ["cu.yd", "cubic yards"],
        factor: 7.64554857984e-1
      },
      {
        name: ["fl.oz(Br)"],
        factor: 2.841305e-5
      },
      {
        name: ["fl.oz(US)"],
        factor: 2.957373e-5
      },
      {
        name: ["gal(Br)"],
        factor: 4.54608782e-3
      },
      {
        name: ["gal(US liq)"],
        factor: 3.78541178e-3
      },
      {
        name: ["pints(Br)"],
        factor: 5.6826092e-4
      },
      {
        name: ["pints(US liq)"],
        factor: 4.731764e-4
      },
      {
        name: ["quarts(Br)"],
        factor: 1.136522e-3
      },
      {
        name: ["quarts(US liq)"],
        factor: 9.4635295e-4
      },
      {
        name: ["pints(US dry)"],
        factor: 5.5061047e-4
      },
      {
        name: ["quarts(US dry)"],
        factor: 1.10122e-3
      },
    ]
  },
  {
    name: ["pressure", "stress", "pression", "contrainte mecanique"],
    units: [
      {
        name: ["Pa"]
      },
      {
        name: ["kPa"],
        factor: 1.e3
      },
      {
        name: ["hPa"],
        factor: 1.e2
      },
      {
        name: ["MPa"],
        factor: 1.e6
      },
      {
        name: ["N/m2"]
      },
      {
        name: ["bar"],
        factor: 1.e5
      },
      {
        name: ["mbar"],
        factor: 1.e2
      },
      {
        name: ["atm (std)"],
        factor: 1.01325e5
      },
      {
        name: ["mm.Hg"],
        factor: 1.333224e2
      },
      {
        name: ["psi", "p.s.i."],
        factor: 6.894757293168e3
      },
      {
        name: ["psig"],
        factor: 6.894757293168e3
      },
      {
        name: ["torr"],
        factor: 1.33322368421e2
      }
    ]
  },
  {
    name: ["force"],
    units: [
      {
        name: ["N"]
      },
      {
        name: ["dyne"],
        factor: 1.e-5
      },
      {
        name: ["kgf"],
        factor: 9.80665
      },
      {
        name: ["lbf"],
        factor: 4.448221615
      },
      {
        name: ["ozf"],
        factor: 2.7801385e-1
      },
      {
        name: ["poundal"],
        factor: 1.38254954e-1
      },
      {
        name: ["kN"],
        factor: 1.e3
      },
      {
        name: ["J/m"]
      },
      {
        name: ["kg-m/s"]
      },
      {
        name: ["J/cm"],
        factor: 1.e2
      }
    ]
  },
  {
    name: ["power", "puissance"],
    units: [
      {
        name: ["W"]
      },
      {
        name: ["kW"],
        factor: 1.e3
      },
      {
        name: ["hp(Br)"],
        factor: 7.457e2
      },
      {
        name: ["kcal/s"],
        factor: 4.18675e3
      },
      {
        name: ["Btu/hr"],
        factor: 2.93071069e-1
      },
      {
        name: ["J/s"]
      },
      {
        name: ["uW"],
        factor: 1.e-6
      },
      {
        name: ["mW"],
        factor: 1.e-3
      },
      {
        name: ["MW"],
        factor: 1.e6
      },
      {
        name: ["GW"],
        factor: 1.e9
      },
      {
        name: ["TW"],
        factor: 1.e12
      },
      {
        name: ["ergs/s"],
        factor: 1.e-7
      }
    ]
  },
  {
    name: ["energy", "work", "energie", "travail"],
    units: [
      {
        name: ["J", "Joules"]
      },
      {
        name: ["Btu"],
        factor: 1.05435e3
      },
      {
        name: ["cal"],
        factor: 4.18675
      },
      {
        name: ["kcal"],
        factor: 4.18675e3
      },
      {
        name: ["erg"],
        factor: 1.e-7
      },
      {
        name: ["ft.lbf"],
        factor: 1.355817948252
      },
      {
        name: ["therms"],
        factor: 1.05505585e8
      },
      {
        name: ["therms(US)"],
        factor: 1.054804e8
      }
    ]
  },
  {
    name: ["density", "specific gravity", "concentration", "concentration", "densite"],
    units: [
      {
        name: ["kg/cu.m"]
      },
      {
        name: ["g/l"]
      },
      {
        name: ["kg/l"],
        factor: 1.e3
      },
      {
        name: ["s.g."],
        factor: 1.e3
      },
      {
        name: ["mg/cc"]
      }
    ]
  }
];
